@if (changes?.length > 0) {
  <button mat-raised-button color="accent" (click)="save()" class="button-confirm">Save changes</button>
}
